export default "__VITE_ASSET__Bj831Rtf__"